import {downloadApi, ajaxApi, ajaxApiGet} from '@/server'
import common from '@/public/common'
import moment from 'moment'
import {getCookie, getSid} from '@/public/utils'
import {get} from "lodash";

const otherAdminName = getCookie('otheradminName') ? JSON.parse(getCookie('otheradminName')) : {}
const UrlLink = common.SapUrl;

// 获取发票相关枚举值
export const fetchEnums = async (params = {}) => {
  const res = await ajaxApiGet({
    url: `${UrlLink}/invoice/get-enums`,
  }) || {}
  return get(res, 'data')
}
// 对账单付款进度查询
export const fetchPaymentProgress = async (params = {}) => {
  const res = await ajaxApi({
    url: `${UrlLink}/payment-progress/query-list`,
    params: {
      ...params,
      query_from_scene: 'scs',
      sid: getSid()
    }
  }) || {}
  return get(res, 'data.data')
}

// 对账单付款进度导出
export const exportPaymentProgress = (params = {}) => {
  return downloadApi(
    `${UrlLink}/payment-progress/export-query-list`,
    {
      ...params,
      query_from_scene: 'scs',
      sid: getSid()
    },
    '对账单付款进度列表' + moment().format('YYYYMMDDHHmmss') + '.xls'
  ) || {}
}
// 查询主体
export const fetchSigoCompany = async (params = {}) => {
  const res = await ajaxApi({
    url: `${UrlLink}/invoice/query-sigo-company-by-sid`,
    params: {
      sid: getSid()
    }
  }) || {}
  return get(res, 'data.data')
}

// 查询供应商
export const fetchSupplier = async (params = {}) => {
  const res = await ajaxApi({
    url: `${UrlLink}/payment-progress/query-supplier-list`
  }) || {}
  return get(res, 'data.data')
}

// 根据对账单查询结算单列表
export const fetchSettlementList = async (code = '') => {
  const res = await ajaxApi({
    url: `${UrlLink}/payment-progress/query-settlement-list`,
    params: {supplier_account_code: code}
  }) || {}
  return get(res, 'data.data')
}

// 查询付款详情
export const fetchPaymentDetail = async (code = '') => {
  const res = await ajaxApi({
    url: `${UrlLink}/payment-progress/supplier-payment/query-payment`,
    params: {statement_code: code}
  }) || {}
  return get(res, 'data.data')
}
// 查询匹配单信息
export const fetchMatchList = async (code = '') => {
  const res = await ajaxApi({
    url: `${UrlLink}/payment-progress/invoice-match/get-match-by-account-no`,
    params: {account_no: code}
  }) || {}
  return get(res, 'data.data')
}



// WEBPACK FOOTER //
// ./src/pages/statementPaymentProgress/request.js